<template>
  <v-container>
    <v-layout column justify-space-around align-space-around>
      <v-flex>
        <h1 class="display-4 font-weight-thin font-italic ">{{mcQuestionWord.emiWord}}</h1>
      </v-flex>
      <v-flex v-for="(choice, item) in choices">
        <v-btn color="indigo" large round 
        :outline="userAnswer!=choice"
        @click="selectAnswer(choice)"
        >
          {{choice.translations[0].translation}}
        </v-btn>
      </v-flex>
      <v-flex>

      </v-flex>
      <v-flex>
        <v-btn @click="handleAnswer" v-if="!answered">Check</v-btn>
        <v-btn @click="handleSubmit" v-else>Next</v-btn>
      </v-flex>
      <v-flex v-if="answered">
        <h1 v-if="correct">Correct</h1>
        <v-flex v-else>
          <h1>Incorrect</h1>
          <h1>Correct answer: {{this.corAns}}</h1>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default{
  name: 'MultipleChoiceQuiz',
  props: {
    word: Object
  },
  data () {
    return {
      correct: false,
      answered: false,
      userAnswer: '',
      corAns: "",
    }
  },
  created () {

  },
  methods: {
    selectAnswer: function(choice){
      this.userAnswer = choice
    },
    handleAnswer: function(){
      this.answered = true;
      this.corAns = this.mcQuestionWord;
      this.correct = this.userAnswer === this.mcQuestionWord
    },
    handleSubmit: function(){
      if(!this.answered)
        this.handleAnswer()
      else
        this.clear()
    },
    clear: function(){
      this.$emit('check', {correct:this.correct});
      this.corAns = "";
      this.answered = false;
    }
  },
  computed:{
     mcQuestionWord: function() {
      var answerWordID = this.word.answers.find(
        answer => answer.correctAnswer === true
      ).answerChoice;
      return this.$store.getters.getVocabByID(answerWordID);
    },
    choices: function() {
      let result = [];
      let mc = this.word.answers;
      if (mc) {
        for(let i = 0; i < mc.length; i++){
          result.push(this.$store.getters.getVocabByID(mc[i].answerChoice))
        }
      }
      return result;
    }
  }
}
</script>

<style scoped>


</style>
